import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "15 12 12 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 5.333h-.75V3.81C9.75 1.707 8.07 0 6 0 3.93 0 2.25 1.707 2.25 3.81v1.523H1.5c-.825 0-1.5.686-1.5 1.524v7.62C0 15.313.675 16 1.5 16h9c.825 0 1.5-.686 1.5-1.524V6.857c0-.838-.675-1.524-1.5-1.524ZM6 12.19c-.825 0-1.5-.685-1.5-1.523 0-.838.675-1.524 1.5-1.524s1.5.686 1.5 1.524S6.825 12.19 6 12.19Zm2.325-6.857h-4.65V3.81c0-1.303 1.043-2.362 2.325-2.362 1.282 0 2.325 1.059 2.325 2.362v1.523Z",
  transform: "translate(15 12)",
  style: {
    fill: "currentColor"
  }
}));

export { SvgLock as default };
